var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrognosis({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    transform: "translate(12.000000, 12.000000) rotate(90.000000) translate(-12.000000, -12.000000) ",
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    transform: "translate(18.000000, 12.000000) rotate(90.000000) translate(-18.000000, -12.000000) ",
    x: 17,
    y: 10,
    width: 2,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    transform: "translate(12.000000, 12.000000) rotate(90.000000) translate(-12.000000, -12.000000) ",
    x: 11,
    y: 10,
    width: 2,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    transform: "translate(6.000000, 12.000000) rotate(90.000000) translate(-6.000000, -12.000000) ",
    x: 5,
    y: 10,
    width: 2,
    height: 4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrognosis);
export default __webpack_public_path__ + "static/media/prognosis.5b18525b8702f5345141e03a34a8ac80.svg";
export { ForwardRef as ReactComponent };